import { IconType } from '@factorialco/f0-react'
import { DateRange } from '@factorialco/f0-react/dist/experimental'

import { AiReportsResult } from 'modules/ai_reports/lib/useCreateAnalyticsReportActionResolver'

import { getRendererDef } from './tableRendererRegistry'
import { DatasourceType } from './types'
import { ColumnFormatHint, datasourceTypeFromId } from './utils'

interface ReportTableAction {
  label: string
  icon: IconType
  onClick: () => void
}

type Props = {
  dateFilter?: DateRange
  reportName: string
  sqlQuery: string
  tableId: string
  actions?: {
    primary?: ReportTableAction
    secondary?: ReportTableAction[]
  }
  columnFormatHints: ColumnFormatHint[]
  setFilters?: (filters: NonNullable<AiReportsResult['filters']>) => void
  onUserFacingSqlQueryChange: (sqlQuery: string) => void
}

const pickRenderer = (datasourceType: DatasourceType) => {
  const def = getRendererDef(datasourceType)

  return def.renderer
}

const DatasourceTypeRenderer = ({
  reportName,
  sqlQuery,
  tableId,
  actions,
  columnFormatHints,
  setFilters,
  dateFilter,
  onUserFacingSqlQueryChange,
}: Props) => {
  const datasourceType = datasourceTypeFromId(tableId)
  const Renderer = pickRenderer(datasourceType)

  return (
    <Renderer
      dateFilter={dateFilter}
      tableId={tableId}
      reportName={reportName}
      sqlQuery={sqlQuery}
      actions={actions}
      columnFormatHints={columnFormatHints}
      setFilters={setFilters}
      onUserFacingSqlQueryChange={onUserFacingSqlQueryChange}
    />
  )
}

export default DatasourceTypeRenderer
